module.exports = {
  SIGN_IN: 'Sign in',
  APPLY_WITH_DOT: 'apply.',
  AND_SYMBOL: '&',
  VERIFY_CODE: 'Verify Code',
  BACK: 'Back',
  OKAY: 'Okay',
  PROCEED_CURRENT_ACCOUNT: 'Proceed with your current account',
  LOG_IN_DIFFERENT_ACCOUNT: 'Log into a different account',
  SIGN_IN_TO_LEEGALITY: 'Sign in to Leegality',
  SIGN_IN_WITH_OTP_HELPER: 'Didn\'t set password or forgot your password? You can always sign in with OTP.',
  SIGN_IN_WITH_SSO_HELPER: 'Didn\'t set password or forgot your password? You can always sign in with SSO.',
  PASSWORD: 'Password',
  FORGOT_PASSWORD: 'Forgot password?',
  SIGN_IN_WITH_OTP: 'Sign in with OTP',
  SIGN_IN_WITH_SSO: 'Sign in with SSO',
  SIGN_IN_WITH_PASSWORD: 'Sign in with password',
  DIDNT_RECEIVE_EMAIL: 'Didn\'t receive the email?',
  RESEND_OTP_IN: 'Resend OTP in',
  RESEND_OTP: 'Resend OTP',
  AND: 'and',
  TERMS_OF_SERVICE: 'Terms of Service',
  PRIVACY_POLICY: 'Privacy Policy',
  NAME: 'Name',
  UPDATE: 'Update',
  SKIP: 'Skip',
  ENTER_YOUR_NAME: 'Enter your name',
  MSG_VAL_TEXT_TEL_NUMBER: 'Please enter a valid mobile phone number',
  MSG_VAL_PASSWORD: 'Please enter a valid password',
  MSG_PASSWORD_AND_CONFIRM_PASSWORD_NOT_MATCH: 'Passwords do not match',
  MSG_VAL_TEXT_EMAIL_OR_TELEPHONE: 'Please enter a valid email address or mobile number',
  MSG_SIGN_IN_TNC: 'By proceeding, you agree to the',
  EMAIL_ID_PHONE_NO: 'Email ID or Phone Number',
  EMAIL_ID: 'Email ID',
  USERNAME_EMAIL_PHONE_NO_LABEL_HINT: 'Email ID and phone number cannot be used interchangeably to log into the same account',
  ENTER_YOUR_EMAIL_PHONE_NUMBER: 'Enter your email id or phone number',
  ENTER_YOUR_EMAIL: 'Enter your email id',
  MULTI_FACTOR_AUTHENTICATION: 'Enter verification code',
  MULTI_FACTOR_AUTHENTICATION_HELPER: 'Enter the code from your authenticator app for Leegality(email@organisation.com)',
  ENTER_YOUR_MFA_VERIFICATION_CODE: 'Enter your verification code',
  MFA_VERIFICATION_CODE: 'Verification code',
  GET_OTP: 'Get OTP',
  POWERED_BY_RECAPTCHA: 'Powered by reCAPTCHA.',
  GOOGLE: 'Google',
  SEND_RESET_PASSWORD_HINT: 'Registered Email Id will receive the reset password link',
  MSG_SEND_RESET_PASSWORD_LINK_SUCCESS: 'Email sent successfully!',
  FORGOT_PASSWORD_HELPER: 'Didn\'t set password or forgot your password?',
  RESET_PASSWORD_EMAIL_HELPER: 'You can reset password from email.',
  RESET_PASSWORD_HEADER: 'Reset Password',
  RESET_PASSWORD_HELPER: 'Set your new password here',
  CONFIRM_PASSWORD: 'Confirm Password',
  RE_ENTER_PASSWORD: 'Re-enter Password',
  PASSWORD_CONFIRM_SUCCESS: 'Password reset',
  MSG_PASSWORD_CONFIRM_SUCCESS: 'Your password has been successfully reset.',
  SEND_RESET_LINK: 'Send Reset Link',
  RESEND_IN: 'Resend in',
  RESEND_LINK: 'Resend Link',
  MSG_UNLOCK_USER_SUCCESS_HEADER: 'SUCCESS',
  MSG_UNLOCK_USER_SUCCESS: 'Your account has been successfully unlocked.',
  MSG_UNLOCK_USER_ERROR_HEADER: 'ERROR',
  MSG_UNLOCK_USER_ERROR: 'Something went wrong while unlocking the user!',
  OTP_SENT_SUCCESS: 'OTP sent successfully',
  NO_ACCOUNT_FOUND: 'No account found',
  CODE_OR_REDIRECT_URL_MISSING: 'Either code or redirect url is missing',
  ACCOUNT_NOT_FOUND_CREATE_NEW: 'We couldn\'t find any existing account with this username. Please create a new account to access Leegality.',
  SIGN_IN_WITH_PUBLIC_OTP: 'Log in to your account',
};
